export class CitationInfo {
    public userName: string | undefined;
    public citationNumber: string | null = null;
    public originalAmount: number | null = null;
    public newAmount: number | null = null;
    public source: string | null = null;
    public historyReason: string | null = null;
    public autoVoid: boolean | null = null;
    public reason: string | null = null;
    public explanation: string | null = null;
}
